module.exports = __webpack_public_path__ + "images/botIcon1738351947b15976562acfd3bd8d6927c.png";